/**
 * corpDashApi.js — API functions for the V2 Corporate Dashboard.
 * Uses direct fetch (corporation_id not supported by apiReport).
 */

import { getAuthHeaders } from '../../../../services/auth';

const getBaseUrl = () =>
    import.meta.env.VITE_DEVMODE === 'true'
        ? import.meta.env.VITE_DEVAPI
        : import.meta.env.VITE_API;

const getHeaders = () => getAuthHeaders();

async function corpFetch(body) {
    try {
        const resp = await fetch(getBaseUrl() + import.meta.env.VITE_MY_REPORTS_ENDPOINT, {
            method: 'POST',
            headers: await getHeaders(),
            body: JSON.stringify(body),
        });
        const raw = await resp.json();
        if (raw?.Status?.toLowerCase() === 'ok') return raw.Res;
        if (raw?.Res) return raw.Res;
        return raw || {};
    } catch (err) {
        console.error('[corpDashApi] fetch error:', err);
        return {};
    }
}

function buildFilterBody(corpId, filters = {}) {
    return {
        corporation_id: corpId,
        area_type_filter: filters.areaTypes || '',
        device_category_filter: filters.deviceCategories || '',
        resp_filter_items: filters.responseTime || [false, 'lt', 60],
    };
}

export function fetchCorpFilterOptions(corpId) {
    return corpFetch({
        rep_type: 'getcorpportalfilters',
        corporation_id: corpId,
        device_category_filter: '1',
        area_type_filter: '1',
    });
}

/**
 * Resident Trends portfolio rollup — one row per trend-enabled campus with
 * open/high counts, 30-day activity, time-to-acknowledge, and 90-day
 * outcome/recurrence rates. Returns { campuses: [] }.
 */
export function fetchTrendPortfolio(corpId) {
    return corpFetch({ rep_type: 'corptrendportfolio', corporation_id: corpId });
}

export function fetchCorpStats(corpId, filters) {
    return corpFetch({ rep_type: 'corpdashboardstatsv2', ...buildFilterBody(corpId, filters) });
}

export function fetchCorpTrends(corpId, filters) {
    return corpFetch({ rep_type: 'corpdashboardtrends', ...buildFilterBody(corpId, filters) });
}

export function fetchCorpHourChart(corpId, campusId, filters) {
    if (campusId === 0) {
        return corpFetch({ rep_type: 'corpdashboardhourchart', ...buildFilterBody(corpId, filters) });
    }
    return corpFetch({
        rep_type: 'dashboardhourchart',
        campus_id: campusId,
        area_type_filter: filters?.areaTypes || '',
        device_category_filter: filters?.deviceCategories || '',
        resp_filter_items: filters?.responseTime || [false, 'lt', 60],
    });
}

import { apiFetch } from '../../../../services/api.js';

export function fetchShiftHours(campusId) {
    if (campusId && campusId !== 0) {
        return apiFetch({ table: 'core_shift_hours', procedure: 'fetchbyparameter', reqType: 'direct', pKey: 'campus_id', pVal: campusId });
    }
    return apiFetch({ table: 'att_shift_default_hours', procedure: 'fetchall', reqType: 'direct' });
}
